import './App.css';

import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import { FileContextProvider } from './context/FileContext';
import { initSentry } from './config/sentry';

import { router } from './routes/router';
import CustomToast from './components/CustomToast/CustomToast';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
import SuccessToast from './components/CustomToast/SuccessToast';
import { ApiCallContextProvider } from './context/ApiCallContext';

const queryClient = new QueryClient();

initSentry();

const App = () => {
  return (
    <CacheBuster
      currentVersion={version}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
      isEnabled={false}
    >
      <div className="App" id="main-app">
        <DndProvider backend={HTML5Backend}>
          <QueryClientProvider client={queryClient}>
            <FileContextProvider>
              <ApiCallContextProvider>
                <RouterProvider router={router} />
                <CustomToast />
                <SuccessToast />
              </ApiCallContextProvider>
            </FileContextProvider>
          </QueryClientProvider>
        </DndProvider>
      </div>
    </CacheBuster>
  );
};

export default App;
